import { defineMessages } from "react-intl";

export const commonComponentTexts = defineMessages({
  statusIsArchived: {
    id: "classification.status.isArchived",
    defaultMessage: "Normally not shown",
  },
});
